import { HTMLAttributes } from 'react';
import { MarketButton } from '@market/react';
import { useTranslation } from 'react-i18next';
import { ValidationResponseAddress } from 'typescript/types/api/address_validation';
import styles from 'typescript/apps/checkout_v3/components/address_validation/address_validation.module.scss';

export const VALIDATION_PARTIALLY_VERIFIED_TEST_ID =
  'validation-partially-verified';
export const USE_CUSTOM_CTA_TEST_ID = 'use-custom-cta';
export const USE_SUGGESTED_CTA_TEST_ID = 'use-suggested-cta';

interface ValidationPartiallyVerifiedProps
  extends HTMLAttributes<HTMLDivElement> {
  correctedAddress: ValidationResponseAddress;
  onOriginalClick: () => void;
  onCorrectedClick: () => void;
}

const ValidationPartiallyVerified = ({
  className,
  correctedAddress,
  onOriginalClick,
  onCorrectedClick,
}: ValidationPartiallyVerifiedProps) => {
  const { t } = useTranslation();
  const {
    address_line_1,
    address_line_2,
    locality,
    administrative_district_level_1,
    postal_code,
  } = correctedAddress;

  return (
    <div
      data-testid={VALIDATION_PARTIALLY_VERIFIED_TEST_ID}
      className={`${styles.container} ${className}`}
    >
      <h3>
        {t('checkout.delivery.validation.suggestion', {
          address: `${address_line_1}${address_line_2 ? `, ${address_line_2}` : ''}`,
        })}
      </h3>
      <p>
        {locality}, {administrative_district_level_1}, {postal_code}
      </p>
      <div className="shop-grid-container">
        <MarketButton
          data-testid={USE_CUSTOM_CTA_TEST_ID}
          className="shop-grid-item-half"
          rank="secondary"
          onClick={onOriginalClick}
        >
          {t('checkout.delivery.validation.useCustom')}
        </MarketButton>
        <MarketButton
          data-testid={USE_SUGGESTED_CTA_TEST_ID}
          className="shop-grid-item-half"
          rank="primary"
          onClick={onCorrectedClick}
        >
          {t('checkout.delivery.validation.useSuggested')}
        </MarketButton>
      </div>
    </div>
  );
};

export default ValidationPartiallyVerified;
